import { BsCurrencyDollar } from "react-icons/bs"; 

const AccountTypeIcon = ({ id }) => {
  if (id === "BANKING") return <span className="align-sub" role="img" aria-label="Bank">🏦</span>;
  if (id === "INVESTMENT") return <span className="align-sub" role="img" aria-label="Investment">📈</span>;
  return <BsCurrencyDollar />;
};

export default AccountTypeIcon;